export default "__VITE_ASSET__BBTrSnpC__"